import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Stack, Typography } from '@mui/material';

interface Props {
  message?: string;
  showAfterDelay?: boolean;
}

export const LoadingLayout: FC<Props> = ({ message, showAfterDelay }) => {
  const { t } = useTranslation();
  const [showLoader, setShowLoader] = useState(!showAfterDelay);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, [showAfterDelay]);

  return (
    <Stack justifyContent="center" alignItems="center" sx={{ flex: 1, minHeight: 200 }}>
      {showLoader && (
        <>
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>
            {message ?? `${t('loading')}...`}
          </Typography>
        </>
      )}
    </Stack>
  );
};
